<template>
    <header class="head-nav" id='header_container'>
        <el-row style="margin:0 10px;">
            <el-col :span="6" class='logo-container'>
                <!-- <img src="../assets/img/logo.png" class='logo' alt=""> -->
                <span class='title'>加阳华枫快运</span>
            </el-col>
            <div class="userinfo">
                <i class="fa fa-sign-out logout" @click='logout'></i>
            </div>
            <div class="userinfo">
                <div class='welcome' v-show="deliveryP">
                    <p class='deliveryP'>派送点：
                        {{deliveryP}}</p>
                </div>
            </div>
            <div class="userinfo">
                <img src="../assets/img/avatar.png" class='avatar' alt="">
                <div class='welcome'>
                    <p class='name comename'></p>
                    <p class='name avatarname'>{{userName}}  {{realeName}}</p>
                </div>
                <!-- <span class='username'>
                    <el-dropdown trigger="click" @command='setDialogInfo'>
                        <span class="el-dropdown-link">
                            <i class="el-icon-caret-bottom el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command='info'>修改信息</el-dropdown-item>
                            <el-dropdown-item command='pass'>修改密码</el-dropdown-item>
                            <el-dropdown-item command='logout'>退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span> -->
                
            </div>
            
            <div class="notify-row">
                <ul class="top-menu">
                    <!-- <li class="li-badge">
                        <a href='#/index'>
                            <el-badge :value="6" class="item one">
                                <i class="fa fa-tasks"></i>
                            </el-badge>
                        </a>
                    </li>
                    <li class="li-badge">
                        <a href='#/index'>
                            <el-badge :value="12" class="item two">
                                <i class="fa fa-envelope-o"></i>
                            </el-badge>
                        </a>
                    </li> -->
                   
                </ul>
            </div>
        </el-row>
    </header>
</template>

<script>
    import * as mUtils from 'utils/mUtils'
    import {axios} from 'utils/'
    import * as book from '../api/book'
    export default {
        name: 'head-nav',

        data() {
            return {
                userName: '',
                itemList: [],
                popupMessage: [],
                unReadNum: 0,
                deliveryP:''
            }
        },
        created() {
            this.userName =  mUtils._getCookie("userName");
            this.realeName=mUtils.getStore("userinfo").realName
            this.getDeliveryP()
        },
        inject:['reload'],
        methods: {
            modifyPwd(){
                this.$router.push({path: '/modifyPwd'});
            },
            logout() {
                mUtils.removeLoginInfo();
                this.$router.push('/');
            },
            showInfoList() {
                this.$router.push({path: '/modifyPersonInfo'});
            },
            getDeliveryP(){
             book.deliveryList({type:2}).then(res=>{
                if(res.status!==200){
                  return this.$message.error("获取用户失败："+res.msg)
                }
                if(res.data.code!==0){
                  return this.$message.error("获取错误："+res.data.msg)
                }
                if(res.data.data.list!=={}){
                  let data=res.data.data.list
                  this.addressList=data
                  for(let i=0;i<data.length;i++){
                    if(data[i].contact==this.realeName){
                      this.deliveryP=data[i].deliveryTitle;
                      localStorage.setItem(
                            "deliveryP",
                            JSON.stringify(this.deliveryP)
                        );
                      return;
                    }
                    let value = null;
                    localStorage.setItem(
                            "deliveryP",
                            JSON.stringify(value)
                        );
                  }
                }
              })
                
            },
            /**
             * 弹出框-修改密码或者系统设置   
             * @param {string} cmditem 弹框类型
             */
            setDialogInfo(cmditem) {
                if (!cmditem) {
                    this.$message('菜单选项缺少command属性');
                    return;
                }
                switch (cmditem) {
                    case 'info':
                        this.showInfoList();
                        break;
                    case 'pass':
                        this.modifyPwd();
                        break;
                    case 'logout':
                        this.logout();
                        break;
                }
            },

        }
    }
</script>

<style scoped lang='less'>
    .logo-container {
        line-height: 60px;
        min-width: 400px;

        .logo {
            height: 50px;
            width: 50px;
            margin-right: 5px;
            vertical-align: middle;
            display: inline-block;
        }

        .title {
            vertical-align: middle;
            font-size: 22px;
            letter-spacing: 3px;
        }
    }

    .fa-user {
        position: relative;
        top: -2px;
        margin-right: 4px;
    }

    .head-nav {
        width: 100%;
        height: 60px;
        min-width: 600px;
        padding: 5px;
        background: url('../assets/img/zhi001.png');
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 100;
        color: #FFF;

        .logout {
            vertical-align: middle;
            cursor: pointer;
        }
    }

    .userinfo {
        line-height: 60px;
        text-align: right;
        float: right;
    }

    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        vertical-align: middle;
        display: inline-block;
    }

    .welcome {
        display: inline-block;
        width: auto;
        vertical-align: middle;
        padding: 0 5px;

        .name {
            line-height: 20px;
            text-align: center;
            font-size: 14px;
        }

        .comename {
            font-size: 12px;
        }

        .avatarname {
            color: #a9d86e;
            font-weight: bolder;
        }
    }

    .username {
        cursor: pointer;
        margin-right: 5px;

        .el-dropdown {
            color: #FFF;
        }
    }

    .border {
        border: 1px solid;
    }

    .notify-row {
        line-height: 60px;
        float: right;
        margin-right: 20px;
        margin-top: 5px;
    }

    ul.top-menu>li {
        float: left;
        margin-right: 20px;
    }

    ul.top-menu>li .bell,
    ul.top-menu>li>a {
        color: #3bc5ff;
        font-size: 16px;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        border: 1px solid #f0f0f8 !important;
        padding: 2px 6px 4px 6px;
        cursor: pointer;
    }



    .messageBlock {
        margin:0 0 7px;
        padding:0;
	}

    .littleDot {
        display: inline-block;
		width: 10px ;
        height: 1em;
        vertical-align: top;
        margin-top: 4px;
    }
    .message{
        display: inline-block;
    }
	.messageContent {
        font-family: 'PingFangSC-Regular', 'PingFang SC';
		color: #353535;
        width: 220px;
		cursor: pointer;
	}
	
	.alink {
		font-family: 'PingFangSC-Regular', 'PingFang SC';
		color: #02A7F0;
		cursor: pointer;
	}
    .userinfo{
      .deliveryP{
        color: #fff;
        font-weight: bolder;
        margin: 0 10px 0 10px;
      }
    }
    
	.visited {
		color: #9a9a9a;
	}

	.noticeTime {
        margin: 12px 0 15px;
		font-family: 'ArialMT', 'Arial';
		font-size: 12px;
        text-align: right;
        color: #9a9a9a;
    }
    // .messageButton {
        
    // }
    .fa-sign-out{
        color: #FFA500;
        font-size: 18px;
    }
</style>


// WEBPACK FOOTER //
// headNav.vue?3d6a5e3a